import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=0105a594&scoped=true&"
import script from "./Balance.vue?vue&type=script&lang=js&"
export * from "./Balance.vue?vue&type=script&lang=js&"
import style0 from "styles/views/account/balance.css?vue&type=style&index=0&id=0105a594&scoped=true&lang=css&"
import style1 from "./Balance.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0105a594",
  null
  
)

export default component.exports